module.exports = __webpack_public_path__ + "static/media/invite-fail.74a9172d.png";